module.exports = __webpack_public_path__ + "img/iconfinder_trello_2317760.a238d673.svg";